import { InjectionToken } from '@angular/core'

import { Observable } from 'rxjs'

/**
 * Signals that the user directory changed, so dependent views can refresh derived counts
 * without depending on whichever scope owns the directory.
 */
export interface IUserDirectoryEvents {
  readonly updated: Observable<string[] | void>
}

export const USER_DIRECTORY_EVENTS = new InjectionToken<IUserDirectoryEvents>(
  'USER_DIRECTORY_EVENTS',
)
